import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2em;

  .modal--content {
    background: #1a1d35;
    border-radius: 12px;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  }

  .modal--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em 2em;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h2 {
      font-size: 1.5rem;
      color: #fff;
      margin: 0 0 0.25em 0;
    }

    .tracking--number {
      font-size: 0.9rem;
      color: rgba(255, 255, 255, 0.6);
      margin: 0;
    }

    .close--btn {
      background: rgba(255, 255, 255, 0.1);
      border: none;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }

  .modal--body {
    padding: 2em;
    overflow-y: auto;
    flex: 1;

    .status--section {
      margin-bottom: 2em;

      .status--badge {
        display: inline-block;
        padding: 0.6em 1.2em;
        border-radius: 8px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 1em;
      }
    }

    .section {
      margin-bottom: 2em;

      &.fee--section {
        background: rgba(33, 150, 243, 0.1);
        border: 1px solid rgba(33, 150, 243, 0.3);
        border-radius: 12px;
        padding: 1.5em;

        .fee--input-group {
          display: flex;
          gap: 1em;
          align-items: flex-end;
          margin-top: 1em;

          .input--wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 0.5em;

            label {
              font-size: 0.85rem;
              color: rgba(255, 255, 255, 0.8);
              font-weight: 500;
            }

            input {
              padding: 0.75em 1em;
              background: rgba(255, 255, 255, 0.05);
              border: 1px solid rgba(255, 255, 255, 0.2);
              border-radius: 8px;
              color: #fff;
              font-size: 1rem;
              transition: border-color 0.2s;

              &:focus {
                outline: none;
                border-color: ${({ theme }) => theme.primary};
              }

              &::placeholder {
                color: rgba(255, 255, 255, 0.3);
              }
            }
          }

          .btn--activate {
            display: flex;
            align-items: center;
            gap: 0.5em;
            white-space: nowrap;

            .icon {
              font-size: 0.9rem;
            }

            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }
        }
      }

      .section--title {
        display: flex;
        align-items: center;
        gap: 0.5em;
        font-size: 1.1rem;
        color: #fff;
        margin: 0 0 1em 0;

        .icon {
          color: ${({ theme }) => theme.primary};
        }
      }

      .info--grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1em;

        .info--item {
          display: flex;
          flex-direction: column;
          gap: 0.5em;

          &.full-width {
            grid-column: span 2;
          }

          .label {
            font-size: 0.75rem;
            color: rgba(255, 255, 255, 0.5);
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .value {
            font-size: 1rem;
            color: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            gap: 0.5em;

            &.price {
              font-size: 1.5rem;
              font-weight: 700;
              color: ${({ theme }) => theme.primary};
            }

            &.payment--status {
              padding: 0.4em 0.8em;
              border-radius: 6px;
              font-size: 0.85rem;
              font-weight: 600;
              width: fit-content;

              &.paid {
                background: rgba(76, 175, 80, 0.15);
                color: #4CAF50;
              }

              &.unpaid {
                background: rgba(255, 152, 0, 0.15);
                color: #FF9800;
              }
            }

            .small-icon {
              font-size: 0.75rem;
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }

      .locations--container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1em;

        .location--item {
          padding: 1em;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 8px;
          border-left: 3px solid;

          &.pickup {
            border-left-color: #4CAF50;
          }

          &.delivery {
            border-left-color: #2196F3;
          }

          .location--header {
            display: flex;
            align-items: center;
            gap: 0.5em;
            font-weight: 600;
            color: #fff;
            margin-bottom: 0.75em;

            .icon {
              font-size: 1rem;
            }
          }

          .address {
            color: rgba(255, 255, 255, 0.9);
            margin: 0 0 0.5em 0;
            font-size: 0.9rem;
          }

          .contact {
            display: flex;
            align-items: center;
            gap: 0.5em;
            color: rgba(255, 255, 255, 0.6);
            font-size: 0.85rem;
            margin: 0;

            .small-icon {
              font-size: 0.7rem;
            }
          }
        }
      }

      .notes {
        padding: 1em;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.6;
        margin: 0;
      }
    }
  }

  .modal--footer {
    padding: 1.5em 2em;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: flex-end;
    gap: 1em;

    .btn {
      padding: 0.75em 1.5em;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.2s;
      border: none;
      display: flex;
      align-items: center;
      gap: 0.5em;
      justify-content: center;

      .icon {
        font-size: 1em;
      }

      &:hover {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &--secondary {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
      }

      &--primary {
        background: ${({ theme }) => theme.primary};
        color: #fff;
      }

      &--track-rider {
        background: #FE7D11 !important;
        color: #fff !important;
        width: 100%;
        margin-top: 1em;
        font-size: 0.95rem;
        padding: 1em 1.5em;
        transition: all 0.3s ease;
        border: 2px solid #FE7D11 !important;
        position: relative;
        overflow: hidden;
        font-weight: 700;
        cursor: pointer;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s ease;
        }

        .icon {
          transition: transform 0.3s ease;
          margin-right: 0.5em;
          color: #fff;
        }

        &:hover {
          background: #FF8C2E !important;
          opacity: 1;
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(254, 125, 17, 0.5);
          border-color: #FFA54D;
          
          &::before {
            left: 100%;
          }

          .icon {
            transform: translateX(4px) scale(1.1);
          }
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(254, 125, 17, 0.4);
          background: #E66D09 !important;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(254, 125, 17, 0.3);
        }
      }
    }
  }

  /* Webhook History Styles */
  .webhook--triggers {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .webhook--trigger {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
    padding: 1em;
    border-left: 3px solid;

    &.success {
      border-left-color: #4CAF50;
    }

    &.failed {
      border-left-color: #EF5350;
    }
  }

  .trigger--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75em;
  }

  .trigger--event {
    display: flex;
    align-items: center;
    gap: 0.5em;

    .icon {
      font-size: 1.1rem;

      &.success {
        color: #4CAF50;
      }

      &.failed {
        color: #EF5350;
      }
    }

    .event--name {
      font-weight: 600;
      color: #fff;
      font-size: 0.9rem;
    }
  }

  .trigger--time {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.5);
  }

  .trigger--details {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  .detail--row {
    display: flex;
    gap: 0.5em;
    font-size: 0.85rem;

    &.error {
      background: rgba(239, 83, 80, 0.1);
      padding: 0.5em;
      border-radius: 4px;
      margin-top: 0.25em;
    }
  }

  .detail--label {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
    min-width: 100px;
  }

  .detail--value {
    color: rgba(255, 255, 255, 0.9);
    word-break: break-word;

    &.url {
      color: #42A5F5;
      font-family: monospace;
      font-size: 0.8rem;
    }

    &.status--2 {
      color: #4CAF50;
      font-weight: 600;
    }

    &.status--4,
    &.status--5 {
      color: #EF5350;
      font-weight: 600;
    }
  }

  .loading--text,
  .empty--text {
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    padding: 1.5em;
    font-size: 0.9rem;
  }
`;